
import About from '../About/About'
import Connect from '../Connect/Connect'
import CountSection from '../Count/Count'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'
import PracticeSection from '../Practice/Practice'
import Slider from '../Slider/Slider'
import TeamSection from '../Team/Team'
import TestimonialSlider from '../Testimonials/Testimonials'
import LawFirmHighlights from '../Three/Three'
import VideoSection from '../Video/Video'
import WhyClientsChooseUs from '../Why/Why'

const Home = () => {
  return (
    <>
      
        <Slider/>
        <LawFirmHighlights/>
        <PracticeSection/>
        <CountSection/>
        <About/>
         <VideoSection/>
        <TeamSection/>
       
         <WhyClientsChooseUs/>
        <TestimonialSlider/>
       
        <Connect/>
      
        
    </>
  )
}

export default Home